interface BonusModalItemProps {
  title: string;
  content?: string | number;
}

export const InfoItem = ({ title, content }: BonusModalItemProps) => {
  return (
    <div className="bg-neutral-50 px-3 py-0.5 rounded-lg w-full flex flex-col gap-0.5 text-left text-text-secondary min-h-[70px] justify-center items-start">
      <p className="text-xs font-medium">{title}</p>
      <p className="text-lg font-semibold">{content}</p>
    </div>
  );
};
